<div class="centered container main-div">
  <app-card-input></app-card-input>
</div>
<div>
  <app-brico-footer></app-brico-footer>
</div>

